import React from "react";

const WizardFooter = ({
  isNextDisabled,
  isFirstStep,
  isSubmitStep,
  saving,
  onBack,
  onNext,
}) => (
  <div
    className={`clinician-onboard-footer${
      isFirstStep ? " clinician-onboard-footer--first" : ""
    }`}
  >
    {!isFirstStep && (
      <button
        type="button"
        className="clinician-onboard-footer__back"
        onClick={onBack}
        disabled={saving}
      >
        Back
      </button>
    )}
    <button
      type="button"
      className="clinician-onboard-footer__next"
      onClick={onNext}
      disabled={isNextDisabled || saving}
    >
      {saving
        ? "Saving..."
        : isFirstStep
        ? "Get started"
        : isSubmitStep
        ? "Submit"
        : "Next"}
    </button>
  </div>
);

export default WizardFooter;
